import {
  Estimate,
  EstimateAcceptResponse,
  EstimateExtras,
  Term,
} from "./estimate";

export type EstimateAction =
  | EstimateCreateAction
  | EstimateSaveExtrasAction
  | EstimateGetAction
  | EstimateGetSuccessAction
  | EstimateSetLoantermAction
  | EstimateSetAmountAction
  | EstimateUpdateRepaymentAction
  | EstimateUpdateQuoteJourneyAction
  | EstimateUpdateNoMatchCountAction
  | EstimateAcceptAction
  | EstimateAcceptSuccessAction
  | EstimateAcceptAmplitudeEventAction;

export const EstimateCreateActionType = "estimate/submit-quote" as const;
export type EstimateCreateAction = ReturnType<typeof estimateCreateAction>;
export function estimateCreateAction(
  quoteRequest: DashboardApi.SubmitRateEstimateRequest,
  wcToken?: string
) {
  return {
    type: EstimateCreateActionType,
    quoteRequest,
    wcToken,
  };
}

export const EstimateSaveExtrasActionType = "estimate/save-extras" as const;
export type EstimateSaveExtrasAction = ReturnType<
  typeof estimateSaveExtrasAction
>;
export function estimateSaveExtrasAction(extras: EstimateExtras) {
  return {
    type: EstimateSaveExtrasActionType,
    extras,
  };
}

export const EstimateGetActionType = "estimate/get" as const;
export type EstimateGetAction = ReturnType<typeof estimateGetAction>;
export function estimateGetAction(
  estimateId: string,
  bid?: string,
  isAppId?: boolean
) {
  return {
    type: EstimateGetActionType,
    estimateId,
    bid,
    isAppId,
  };
}

export const EstimateGetSuccessActionType = "estimate/get-success" as const;
export type EstimateGetSuccessAction = ReturnType<
  typeof estimateGetSuccessAction
>;
export function estimateGetSuccessAction(estimate: Estimate) {
  return {
    type: EstimateGetSuccessActionType,
    estimate,
  };
}

export const EstimateSetLoantermActionType = "estimate/set-loan-term" as const;
export type EstimateSetLoantermAction = ReturnType<
  typeof estimateSetLoantermAction
>;
export function estimateSetLoantermAction(
  loanterm: number,
  editing?: boolean,
  estimateAcceptResponse?: EstimateAcceptResponse,
  firstName?: string,
  dashboardLoanApplicationEnabled?: boolean
) {
  return {
    type: EstimateSetLoantermActionType,
    loanterm,
    editing,
    estimateAcceptResponse,
    firstName,
    dashboardLoanApplicationEnabled,
  };
}

export const EstimateSetAmountActionType = "estimate/set-amount" as const;
export type EstimateSetAmountAction = ReturnType<
  typeof estimateSetAmountAction
>;
// This action and its epic is unused
/* istanbul ignore next */
export function estimateSetAmountAction(loanAmount: number) {
  return {
    type: EstimateSetAmountActionType,
    loanAmount,
  };
}

export const EstimateUpdateRepaymentActionType =
  "estimate/update-repayment" as const;
export type EstimateUpdateRepaymentAction = ReturnType<
  typeof estimateUpdateRepaymentAction
>;
export function estimateUpdateRepaymentAction(estimate: Estimate) {
  return {
    type: EstimateUpdateRepaymentActionType,
    estimate,
  };
}

export const EstimateUpdateQuoteJourneyActionType =
  "estimate/update-journey" as const;
export type EstimateUpdateQuoteJourneyAction = ReturnType<
  typeof estimateUpdateQuoteJourneyAction
>;
export function estimateUpdateQuoteJourneyAction(quoteId: string) {
  return {
    type: EstimateUpdateQuoteJourneyActionType,
    quoteId,
  };
}

export const EstimateUpdateNoMatchCountActionType =
  "estimate/update-no-match" as const;

export type EstimateUpdateNoMatchCountAction = ReturnType<
  typeof estimateUpdateNoMatchCountAction
>;

export function estimateUpdateNoMatchCountAction() {
  return {
    type: EstimateUpdateNoMatchCountActionType,
  };
}

export const EstimateAcceptActionType = "estimate/accept" as const;

export type EstimateAcceptAction = ReturnType<typeof estimateAcceptAction>;

export function estimateAcceptAction(quoteId: string, term: Term) {
  return {
    type: EstimateAcceptActionType,
    quoteId,
    term,
  };
}

export const EstimateAcceptSuccessActionType =
  "estimate/accept-success" as const;

export type EstimateAcceptSuccessAction = ReturnType<
  typeof estimateAcceptSuccessAction
>;

export function estimateAcceptSuccessAction(
  estimateAcceptResponse: EstimateAcceptResponse
) {
  return {
    type: EstimateAcceptSuccessActionType,
    estimateAcceptResponse,
  };
}

export const EstimateAcceptAmplitudeEventActionType =
  "estimate/accept-amplitude-event" as const;

export type EstimateAcceptAmplitudeEventAction = ReturnType<
  typeof estimateAcceptAmplitudeEventAction
>;

export function estimateAcceptAmplitudeEventAction(
  wisrApplicationId: string,
  eventName: string,
  isPrefill?: boolean
) {
  return {
    type: EstimateAcceptAmplitudeEventActionType,
    wisrApplicationId,
    eventName,
    isPrefill,
  };
}
